import React, { useEffect } from 'react';
import kws from '../images/clients/laugh.png';
import geps from '../images/clients/mona1.png';
//import protergia from '../images/clients/printcare.png';

const clientImage = {
    height: '5rem',
    width: 'auto',
    mixBlendMode: 'colorBurn'
};

const Clients = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
    <div id='clients' className="bg-gray-100 py-12">
        <section data-aos="fade-up">
        <div className="my-4 py-4">
            <h2 className="my-2 text-center text-3xl uppercase font-bold" style={{ color: '#005690' }}>
            Our Clients
            </h2>
            <div className='flex justify-center'>
            <div className='w-24 border-b-4' style={{ borderColor: '#005690' }}></div>
            </div>
        </div>

        <div className="p-16" data-aos="fade-in" data-aos-delay="600">
            {/* Vertical stack of clients */}
            <div className="flex flex-col items-center space-y-6">
            <div className="bg-white p-4 rounded-lg shadow-md overflow-hidden flex items-center justify-center transition-all ease-in-out hover:scale-105">
                <img src={geps} alt="client" style={clientImage} />
            </div>

            {/* <div className="bg-white p-4 rounded-lg shadow-md overflow-hidden flex items-center justify-center transition-all ease-in-out hover:scale-105">
                <img src={protergia} alt="client" style={clientImage} />
            </div> */}


            </div>
        </div>
        </section>
    </div>
    );

};

export default Clients;
